import React from "react";
import { getUserInitials } from "@app/utils/user";
import type { User } from "@prisma/client";
import { UserWithMyRooms } from "@api/src/types/user";

interface ProfileButtonProps {
  user: Pick<User | UserWithMyRooms, "id" | "firstName" | "lastName" | "avatar">;
  className?: string;
  children?: React.ReactNode;
}

export default function ProfileButton({ user, className = "", children }: ProfileButtonProps) {
  return (
    <span
      className={`flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-sky-900 bg-white text-sky-900 ${className}`}
    >
      {user?.avatar ? (
        <img
          className="h-full w-full object-cover"
          src={user.avatar}
          loading="lazy"
          alt={`Avatar de ${user?.firstName} ${user?.lastName}`}
        />
      ) : (
        getUserInitials(user)
      )}
      {children}
    </span>
  );
}
